export default __webpack_public_path__ + "static/media/2005.594c7511.png";